const RequiredBadge = () => <span className="inline-flex items-center px-2.5 py-0.5 rounded-md bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 text-xs font-medium">Required</span>;

export default RequiredBadge;
